import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import { withRouter } from 'react-router-dom';

class StandCreate extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      name: '',
      description: '',
      coordinates: '',
      nameErrorText: '',
      errorMessage: ''
    };

    this.state = {
      ...this.initialState
    };
  }
  handleNameChange = (event, name) => {
    this.setState({nameErrorText: '', name});
  }
  handleDescriptionChange = (event, description) => {
    this.setState({description});
  }
  handleCoordinatesChange = (event, coordinates) => {
    this.setState({coordinates});
  }
  handleCancel = () => {
    this.setState({ ...this.initialState});
    this.props.handleClose();
  }
  validateName = () => {
    const {t} = this.props;
    if(!this.state.name) {
      this.setState({nameErrorText: t('required')});
      return false;
    }
    return true;
  }
  handleSave = () => {
    const {firebase, user} = this.props;
    if (this.validateName()) {

      const stand = {
        name: this.state.name,
        description: this.state.description,
        coordinates: this.state.coordinates
      };

      firebase.database().ref(`shopkeepers/${user.shopkeeperId}/stands/`).push(stand).then((data) => {
        firebase.database().ref(`shopkeepers/${user.shopkeeperId}/standsList/${data.key}`).set(stand);
        this.props.history.push(`/stands/${data.key}`);
      });
      this.handleCancel();
    }

  }
  render() {
    const {t} = this.props;

    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleCancel}
      />,
      <RaisedButton
        label={t('submit')}
        type="submit"
        primary={true}
        onTouchTap={this.handleSave}
      />,
    ];

    return (
      <Dialog
          title={t('stand.create')}
          open={this.props.open}
          onRequestClose={this.handleCancel}
          actions={actions}
        >
          <TextField hintText={t('stand.name')}
            floatingLabelText={t('stand.name')}
            errorText={this.state.nameErrorText}
            onChange={this.handleNameChange}
            onBlur={this.validateName}
            value={this.state.name}
          />
          <br />
          <TextField hintText={t('stand.description')}
            floatingLabelText={t('stand.description')}
            onChange={this.handleDescriptionChange}
            value={this.state.description}
          />
          <br />
          <TextField hintText={t('stand.coordinates')}
            floatingLabelText={t('stand.coordinates')}
            onChange={this.handleCoordinatesChange}
            value={this.state.coordinates}
          />
            <div style={{
              color: '#F44336',
            }}>{this.state.errorMessage}
          </div>
        </Dialog>
    );
  }
}

const enhance = compose(translate(), firebase, user, withRouter);

export default enhance(StandCreate);



// WEBPACK FOOTER //
// ./src/Stand/StandCreate.js